import { type FC } from 'react';

// components
import { Link } from 'dibs-elements/exports/Link';
import { FormattedMessage } from 'dibs-react-intl';

// styles
import styles from './PdpSharedAuctionEndedLink.scss';

export const PdpSharedAuctionEndedLink: FC = () => (
    <div className={styles.container}>
        <span data-tn="pdp-countdown-bidding-closed">
            <FormattedMessage
                id="PdpSharedAuctionEndedLink.completeActive"
                defaultMessage="Auction ended"
            />
        </span>
        <Link href="/auctions/" className={styles.link}>
            <FormattedMessage
                id="PdpSharedAuctionEndedLink.browse"
                defaultMessage="Browse Current Auctions"
            />
        </Link>
    </div>
);
